import BaseService from '../BaseService.js'

export default class SchedulerService extends BaseService {

  constructor() {
    super('scheduler')
  }

  async restartScheduler() {
    await this.getImportBackendListUrl('startImport').then(url => this.serviceurl = url)
    return this.checkError(
      fetch(`${this.serviceurl}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
